import * as types from './_actionTypes';

export const fetchAvailableQuizzesRequest = () => ({
  type: types.FETCH_AVAILABLE_QUIZZES_REQUEST
});

export const fetchAvailableQuizzesSuccess = (quizzes) => ({
  type: types.FETCH_AVAILABLE_QUIZZES_SUCCESS,
  payload: quizzes
});

export const fetchAvailableQuizzesFailure = (error) => ({
  type: types.FETCH_AVAILABLE_QUIZZES_FAILURE,
  payload: error
});

export const startQuizRequest = (quizId) => ({
  type: types.START_QUIZ_REQUEST,
  payload: quizId
});

export const startQuizSuccess = (quiz) => ({
  type: types.START_QUIZ_SUCCESS,
  payload: quiz
});

export const startQuizFailure = (error) => ({
  type: types.START_QUIZ_FAILURE,
  payload: error
});

export const submitQuizRequest = (quizId, answers) => ({
  type: types.SUBMIT_QUIZ_REQUEST,
  payload: { quizId, answers }
});

export const submitQuizSuccess = (result) => ({
  type: types.SUBMIT_QUIZ_SUCCESS,
  payload: result
});

export const submitQuizFailure = (error) => ({
  type: types.SUBMIT_QUIZ_FAILURE,
  payload: error
});

export const updateQuizAnswer = (questionId, answer) => ({
  type: types.UPDATE_QUIZ_ANSWER,
  payload: { questionId, answer }
});

export const fetchQuizResultsRequest = () => ({
  type: types.FETCH_QUIZ_RESULTS_REQUEST
});

export const fetchQuizResultsSuccess = (results) => ({
  type: types.FETCH_QUIZ_RESULTS_SUCCESS,
  payload: results
});

export const fetchQuizResultsFailure = (error) => ({
  type: types.FETCH_QUIZ_RESULTS_FAILURE,
  payload: error
});